<template>
  <div class="wrapper continue">
    <div class="price-section">
      <p class="price">{{ price | money }} </p>
      <p class="price-text">{{ $t('participants.totalprice') }}</p>
    </div>
    <ria-button class="uppercase" :text="buttonText" :action="buttonAction" :active="active"/>
  </div>
</template>

<script>
  import RiaButton from "./ria-button";

  export default {
    name: "continue",
    components: {
      RiaButton
    },
    props: {
      price: Number,
      buttonText: String,
      buttonAction: Function,
      active: {
        type: Boolean,
        default: false
      }
    }
  };
</script>

<style scoped>

  .continue {
    @apply relative;
  }

  .wrapper {
    @apply w-full py-3.5 px-5 flex justify-between items-center bg-white z-5 border-t-1 border-b-1 border-grey-border;
  }

  .price {
    @apply text-lg text-black text-left font-medium;
  }

  .price-text {
    @apply text-xs text-grey-text text-left;
  }

  @screen lg {
    .price-section {
      @apply invisible;
    }

    .wrapper {
      @apply border-t-0 relative;
    }
  }

</style>
